// chain_events describe the structure of contract specific events like
// "Deposited", "Withdrawn" etc.
// To stay futureproof, we want to impose our own types instead of exposing the
// typechain generated events types, which are rather cumbersome to use anyway.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ethCallbackShim = void 0;
const api_1 = require("../../api");
const ledger_1 = require("./..");
const assets_1 = require("../assets");
function ethCallbackShim(erdstall, tokenProvider, ev, cb) {
    switch (ev) {
        case "Frozen":
            return wrapFrozen(erdstall, cb);
        case "Deposited":
            return wrapDeposited(erdstall, tokenProvider, cb);
        case "Withdrawn":
            return wrapWithdrawn(erdstall, tokenProvider, cb);
        case "TokenRegistered":
            return wrapTokenRegistered(erdstall, cb);
        case "TokenTypeRegistered":
            return wrapTokenTypeRegistered(erdstall, cb);
        case "Challenged":
            return wrapChallenged(erdstall, cb);
        case "ChallengeResponded":
            return wrapChallengeResponded(erdstall, tokenProvider, cb);
    }
}
exports.ethCallbackShim = ethCallbackShim;
function wrapFrozen(erdstall, cb) {
    const wcb = async (epoch) => {
        return cb({ epoch: epoch.toBigInt() });
    };
    return wcb;
}
function wrapDeposited(erdstall, tokenProvider, cb) {
    const wcb = async (epoch, account, token, value) => {
        const assets = await assets_1.decodePackedAssets(erdstall, tokenProvider, [
            [token, value],
        ]);
        return cb({
            epoch: epoch.toBigInt(),
            address: ledger_1.Address.fromString(account),
            assets: assets,
        });
    };
    return wcb;
}
function wrapWithdrawn(erdstall, tokenProvider, cb) {
    const wcb = async (epoch, account, values) => {
        const assets = await assets_1.decodePackedAssets(erdstall, tokenProvider, values);
        return cb({
            epoch: epoch.toBigInt(),
            address: ledger_1.Address.fromString(account),
            tokens: assets,
        });
    };
    return wcb;
}
function wrapTokenRegistered(erdstall, cb) {
    const wcb = async (token, tokenType, tokenHolder) => {
        return cb({
            token: ledger_1.Address.fromString(token),
            tokenHolder: ledger_1.Address.fromString(tokenHolder),
            tokenType: assets_1.requireTokenType(tokenType),
        });
    };
    return wcb;
}
function wrapTokenTypeRegistered(erdstall, cb) {
    const wcb = async (tokenType, tokenHolder) => {
        return cb({
            tokenHolder: ledger_1.Address.fromString(tokenHolder),
            // TODO: How do we cope with newly registered tokentypes?
            tokenType: tokenType,
        });
    };
    return wcb;
}
function wrapChallenged(erdstall, cb) {
    const wcb = async (epoch, account) => {
        return cb({
            epoch: epoch.toBigInt(),
            address: ledger_1.Address.fromString(account),
        });
    };
    return wcb;
}
function wrapChallengeResponded(erdstall, tokenProvider, cb) {
    const wcb = async (epoch, account, tokens, sig) => {
        const assets = await assets_1.decodePackedAssets(erdstall, tokenProvider, tokens);
        return cb({
            epoch: epoch.toBigInt(),
            address: ledger_1.Address.fromString(account),
            tokens: assets,
            sig: new api_1.Signature(sig),
        });
    };
    return wcb;
}
//# sourceMappingURL=ethwrapper.js.map